import type RetsOpenHouse from '@bb/domain/dist/types/RetsOpenHouse';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const findById = async (id: string) => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `/rets/openhouse/${id}`,
  };

  const { data } = await axios.request<RetsOpenHouse>(config);

  return data;
};

export default findById;
